import Alert from '@amzn/meridian/alert';
import Box from '@amzn/meridian/box';
import Column from '@amzn/meridian/column';
import Loader from '@amzn/meridian/loader';
import React from 'react';
import { PropType } from '../types/PreLoginLandingPage.types';
import { ErrorMessages } from '../constants/ErrorMessages';
const logo = require("../assests/logo.svg");

const PreLoginLandingPage = (props: PropType) => {
  const { error, isErrorBoundaryFallback } = props;
  const {SOMETHING_WENT_WRONG, ERROR_FAILED_TO_SIGN_IN, ERROR_BOUNDARY, PRE_LOGIN_ERROR } = ErrorMessages
  return (
    <Column height="100vh" alignmentHorizontal="center" alignmentVertical="center" data-testid="preloginlandingpage-container-column">
      <Box data-testid="preloginlandingpage-content-box">
        <Column alignmentHorizontal="center" spacing="500" data-testid="preloginlandingpage-inner-column">
          <img width="230rem" src={logo} alt="Smartbiz Logo" />
          {error ? (
            <Alert
              data-testid="preloginlandingpage-error-alert"
              toast={true}
              type="error"
              width={800}
              title={
                isErrorBoundaryFallback ? SOMETHING_WENT_WRONG : ERROR_FAILED_TO_SIGN_IN
              }
            >
              {isErrorBoundaryFallback ? ERROR_BOUNDARY : PRE_LOGIN_ERROR}
            </Alert>
          ) : (
            <Loader type="linear" size="small" data-testid="preloginlandingpage-loading-loader" />
          )}
        </Column>
      </Box>
    </Column>
  );
};

export default PreLoginLandingPage;
